import { render, staticRenderFns } from "./LeadsForm.vue?vue&type=template&id=60474816&scoped=true&"
import script from "./LeadsForm.vue?vue&type=script&lang=js&"
export * from "./LeadsForm.vue?vue&type=script&lang=js&"
import style0 from "./LeadsForm.vue?vue&type=style&index=0&id=60474816&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60474816",
  null
  
)

export default component.exports